// Per-serving nutrition estimate as the API returns it, and its one-line form.

export interface Nutrition {
  kcal: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
  source: "house" | "llm";
}

/** "18 P · 105 C · 19 F" — grams per serving. */
export function macros(n: Nutrition): string {
  return `${n.protein_g} P · ${n.carbs_g} C · ${n.fat_g} F`;
}
